(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();
      this.header.classList.add('shopify-section-header-sticky');
      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.onMediaChange = this.setHeaderHeight.bind(this);
      this.mediaQuery.addEventListener('change', this.onMediaChange);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mediaQuery?.removeEventListener('change', this.onMediaChange);
    }

    reveal() {
      this.header?.classList.add('shopify-section-header-sticky');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
